// Bezochte pagina's voor het Systeemlogboek (ticket 86c47jc83): na elke
// navigatie meldt de app welke pagina een ingelogde gebruiker opende.
//
// De server haalt de gebruiker uit het token, niet uit de body: bij de eerste
// navigatie staat de gebruiker in de store nog op id -1 (/me/info is dan nog
// onderweg), dus daar wachten zou die eerste pagina missen.
//
// Bewust import-vrij: scripts/test-page-visit-beacon.mjs laadt dit bestand als
// data-URL-module.

const DEDUPE_MS = 30 * 1000;

// Hosts zonder Bedrijfspagina: daar hoort geen bezoek bij een bedrijf.
const LOGIN_HOSTS = [
  "localhost",
  "staging-app.nl",
  "inloggen.staging-app.nl",
  "dfm-app.nl",
  "inloggen.dfm-app.nl",
  "connect.dfm-app.nl",
  "connect.staging-app.nl",
  "inloggen.test.local",
];

// Aanmeld- en wachtwoordschermen zijn geen bezoek aan de app.
const SKIPPED_PREFIXES = [
  "/inloggen",
  "/otp",
  "/registreren",
  "/registratie-voltooien",
  "/wachtwoord-wijzigen",
  "/wachtwoord-vergeten",
  "/welcome",
  "/verbinden",
];

/** Het pad zoals het gelogd wordt: zonder query, het Specialistlink-token weggelakt. */
export function beaconPath(path) {
  const bare = String(path || "/").split(/[?#]/)[0] || "/";

  return bare.replace(/^\/link\/[^/]+/, "/link/…");
}

export function isLoginHost(hostname) {
  return LOGIN_HOSTS.includes(hostname) || hostname.endsWith(".localhost");
}

export function isSkipped(path) {
  return SKIPPED_PREFIXES.some((prefix) => path === prefix || path.startsWith(prefix + "/"));
}

/**
 * De beacon zelf. `send` post het bezoek en mag niet gooien; `hasSession`
 * zegt of er een tokencookie is; `hostname` geeft de huidige host.
 */
export function createPageVisitBeacon({ send, hasSession, hostname, now = () => Date.now() }) {
  let last = { path: null, at: 0 };

  return function recordVisit(path) {
    const host = hostname();
    if (!hasSession() || isLoginHost(host) || isSkipped(path)) return false;

    const logged = beaconPath(path);
    const at = now();
    if (logged === last.path && at - last.at < DEDUPE_MS) return false;
    last = { path: logged, at };

    send({ path: logged, page: host.split(".", 1)[0] });

    return true;
  };
}
